<template>

<div ref="Section1">
  <div id="container">
  <h1>Between 2018 and 2022, More than 2000 sea turtles were found in Thai's ocean</h1>
  </div>
<div ref="mainVisualization"></div>
</div>

<div ref="Section2">
<div id ="container2">
<h2>The turtle were showing up more and more during 2021</h2>
</div>
<div ref="secondaryVisualization"></div>
</div>


  
<h3>Eggs Only Chart</h3>
<div ref="eggsOnlyChart"></div>

<h3>Hatch Replacing Eggs Chart</h3>
<div ref="hatchReplacingEggsChart"></div>


<div ref="Section4">
  <h3>Waffle Chart with Turtle Types (Legend)</h3>
  <div ref="waffleChart"></div>
</div>

<div ref="Section5"> 
    <h3>The number of strand</h3>
    <div ref="totalChart"></div>
    <h3>The proportion of survival</h3>
    <div ref="alivedeadChart"></div>
  </div>

  <div ref="Section6">
<h1>The Strand reason</h1>
<h4> As the data between 2020 and 2022, <br> We can see that the number of Sea turtle in Thailand is decreased</h4>
<div ref="sixthVisualization"></div>
</div>

<div ref="Section7">
<h1>The trash effect</h1>
<h4> Fromt the reason that sea turtle starnd by trash</h4>
<div ref="sevenVisualization"></div>

</div>

<div ref="Section8">
<h1>The Trash proportion</h1>
<div ref="trashyearVisualization"></div>
<div ref="eightVisualization"></div>
</div>

<div ref="Section9">
  <div ref="tenVisualization"></div>
</div>


</template>
  
<script>
import * as d3 from 'd3';

export default {
  mounted() {
    this.fetchData();
    this.fetchSecondaryData();
    this.fetchFourthData();
    this.fetchTurtleData();
    this.fetchFifthData();
    this.fetchSixthData();
    this.fetchSevenData();
    this.fetchEightData();
    this.fetchNinethData();
    this.fetchTenData();

  },
  methods: {

  fetchData() {
  fetch('turtleachyear.json')
    .then(response => response.json())
    .then(data => {
      this.createMainVisualization(data);
    })
    .catch(error => {
      console.error('Error fetching main data:', error);
    });
},

createMainVisualization(data) {
  const width = window.innerWidth;
  const height = window.innerHeight;

  // Function to get a random radius between 2 and 12
  const getRandomRadius = () => Math.random() * 10 + 2;

  const svg = d3.select(this.$refs.mainVisualization).append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("style", "display: block; margin: auto;");

  svg.append("rect")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "none");

  let dots = [];
  data.forEach(item => {
    for (let i = 0; i < item.Counts; i++) {
      dots.push({
        finalX: Math.random() * width,
        finalY: Math.random() * (height - 100) + 50, // Keep some margin at the top
        radius: getRandomRadius() // Assign a random radius
      });
    }
  });

  const dotElements = svg.selectAll("circle.dot")
    .data(dots)
    .enter().append("circle")
    .attr("class", "dot")
    .attr("cx", dot => dot.finalX)
    .attr("cy", height + 10) // Start below the screen for water bubble effect
    .attr("r", 0) // Start with radius 0
    .style("opacity", 0) // Start fully transparent
    .style("fill", "white");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        dotElements
          .transition()
          .ease(d3.easeCubicOut) // Smooth easing effect
          .duration(3000) // Slow duration for water bubble effect
          .delay((_, i) => i * 100) // Slight delay between each bubble
          .attr("cy", dot => dot.finalY - 50) // Bubble rises up to 50 units higher than finalY
          .attr("r", dot => dot.radius) // Animate to the random radius
          .style("opacity", 0.5); // Final opacity

        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  observer.observe(svg.node());
},

fetchSecondaryData() {
        // Fetch data for the secondary visualization
        fetch('turtleachyear.json') // Replace with the path to your secondary data file
          .then(response => response.json())
          .then(data => {
            // Once data is fetched, call the method to create the secondary visualization
            this.createProportionalAreaChartHorizontal (data);
          })
          .catch(error => {
            console.error('Error fetching secondary data:', error);
          });
      },

createProportionalAreaChartHorizontal(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 60 : 20; // Gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles

  // Calculate the number of items per row dynamically based on available width
  const itemsPerRow = 5;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain(data.map(d => d.Year)); // Assuming 'Types' is unique

  // Calculate total number of rows
  const totalRows = Math.ceil(data.length / itemsPerRow);

  // Calculate total width and height of the grid
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - (itemsPerRow * (squareSide + gap))) / 2;
const yOffset = (400 - gridHeight) / 2; // ปรับตำแหน่งของแกน Y เพื่อให้ชาร์ตอยู่กลางของหน้าจอ

const svg = d3.select(this.$refs.secondaryVisualization).append("svg")
  .attr("width", window.innerWidth)
  .attr("height", 400)
  .append("g")
  .attr("transform", `translate(${xOffset}, ${yOffset})`);

const chartGroup = svg.append("g");

data.forEach((d, i) => {
  const maxCount = Math.max(...data.map(d => d.Counts));
  const colIndex = i % itemsPerRow;
  const rowIndex = Math.floor(i / itemsPerRow);
  const x = colIndex * (squareSide + gap);
  const y = rowIndex * (squareSide + labelHeight + gap);

  const g = chartGroup.append("g").attr("transform", `translate(${x}, ${y})`);
  let rectHeight = Math.max(d.Counts * (80 / maxCount), minHeight);

    g.append("rect")
      .attr("class", "outer-container")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "transparent")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    const innerRectY = squareSide - rectHeight;
    const innerRect = g.append("rect")
      .attr("class", "container")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", "transparent")
      .attr("stroke-width", 1);

    const dots = Array.from({ length: d.Counts }, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * (rectHeight - 2) + innerRectY + 1,
      color: colorScale(d.Year)
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter().append("circle")
      .attr("class", "dot")
      .attr("cx", d => d.x)
      .attr("cy", 0)
      .attr("r", 0)
      .style("fill", d => d.color);

    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + 15)
      .attr("text-anchor", "middle")
      .text(d.Year);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0)
            .attr("r", 0)
            .transition()
            .duration(1000)
            .delay((_, i) => i * 5)
            .attr("cy", d => d.finalY)
            .attr("r", 3);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},
fetchFourthData() {
  fetch('sea_turtle_egg.json')
    .then(response => response.json())
    .then(originalData => {
      const data = originalData.map(d => ({
        Year: d.Year,
        Egg: Number(d.Egg),
        Hatch: Number(d.Hatch)
      }));

      this.createEggsOnlyChart(data);
      this.createHatchReplacingEggsChart(data);
    })
    .catch(error => {
      console.error('Error fetching JSON data:', error);
    });
},
createEggsOnlyChart(data) {
  const svgWidth = window.innerWidth;
  const svgHeight = window.innerHeight;
  const svg = d3.select(this.$refs.eggsOnlyChart).append('svg')
    .attr('width', svgWidth)
    .attr('height', svgHeight);

  const iconEgg = 'egg.svg'; // SVG path starting from the public directory
  const iconUnits = 1000;
  const iconWidth = 40;
  const iconHeight = 40;
  const horizontalSpacing = 50;
  const rowHeight = 140; // Increased row height for more spacing
  const maxIconsPerRow = 25;
  const fontSize = 16; // Font size for the legend text
  const legendText = ' = 1000 units'; // Define the legend text
// Calculate text width approximately (assuming roughly 8 pixels per character average at font size 16)
const textWidth = legendText.length * 8;

// Calculate the starting x position for the icon so that the entire legend (icon + text) is centered
const startX = (svgWidth - (iconWidth + textWidth + 10)) / 2; // 10 pixels padding between icon and text

// Append the icon for the legend
svg.append('image')
  .attr('xlink:href', iconEgg)
  .attr('x', startX)
  .attr('width', iconWidth)
  .attr('height', iconHeight);

// Append the text for the legend
svg.append('text')
  .attr('x', startX + iconWidth + 10) // Start text right after the icon with 10 pixels padding
  .attr('y', 25) // Align text vertically with the center of the icon
  .attr('font-size', fontSize)
  .attr('font-weight', 'bold')
  .attr('text-anchor', 'start') // Start the text at the specified x position
  .text(legendText);

 

  const totalHeight = data.length * rowHeight;
  const yOffset = (svgHeight - totalHeight) / 2; // Calculate offset to center the visualization vertically

  data.forEach((d, i) => {
    const eggCount = Math.ceil(d.Egg / iconUnits);
    const actualIconsThisRow = Math.min(eggCount, maxIconsPerRow);
    const actualRowWidth = actualIconsThisRow * horizontalSpacing;
    const xPosition = (svgWidth - actualRowWidth) / 2;

    const yPosition = yOffset + i * rowHeight; // Adjust y position based on offset

    svg.append('text')
      .attr('x', xPosition)
      .attr('y',yPosition + iconHeight / 2 + 20)
      .attr('font-size', 16)
      .attr('font-weight', 'bold')
      .attr('text-anchor', 'end')
      .text(d.Year);

    const eggGroup = svg.append('g')
      .attr('transform', `translate(${xPosition}, ${yPosition})`);

    eggGroup.selectAll('image')
      .data(Array.from({ length: eggCount }))
      .enter()
      .append('image')
      .attr('xlink:href', iconEgg)
      .attr('width', iconWidth)
      .attr('height', iconHeight)
      .attr('x', (d, j) => (j % maxIconsPerRow) * horizontalSpacing)
      .attr('y', (d, j) => Math.floor(j / maxIconsPerRow) * iconHeight);
  });
},

createHatchReplacingEggsChart(data) {
  const svgWidth = window.innerWidth;
  const svgHeight = window.innerHeight;
  const svg = d3.select(this.$refs.hatchReplacingEggsChart).append('svg')
    .attr('width', svgWidth)
    .attr('height', svgHeight);

  const iconEgg = 'egg.svg'; // SVG path starting from the public directory
  const iconHatch = 'turhat.svg'; // SVG path starting from the public directory
  const iconUnits = 1000;
  const iconWidth = 40;
  const iconHeight = 40;
  const horizontalSpacing = 50;
  const rowHeight = 140; // Increased row height for more spacing
  const maxIconsPerRow = 25;

  const totalHeight = data.length * rowHeight;
  const yOffset = (svgHeight - totalHeight) / 2; // Calculate offset to center the visualization vertically

  data.forEach((d, i) => {
    const eggCount = Math.ceil(d.Egg / iconUnits);
    const hatchCount = Math.ceil(d.Hatch / iconUnits); // Define hatchCount here
    const yPosition = yOffset + i * rowHeight; // Adjust y position based on offset

    const actualIconsThisRow = Math.min(eggCount, maxIconsPerRow);
    const actualRowWidth = actualIconsThisRow * horizontalSpacing;
    const xPosition = (svgWidth - actualRowWidth) / 2;

    // Adjust text position to ensure visibility
    svg.append('text')
      .attr('x', xPosition - 10) // Slightly left from the icons
      .attr('y', yPosition + iconHeight / 2 + 20) // Vertically centered in the row
      .attr('font-size', 16)
      .attr('font-weight', 'bold')
      .attr('text-anchor', 'end')
      .text(d.Year);

    const eggGroup = svg.append('g')
      .attr('transform', `translate(${xPosition}, ${yPosition})`);

    let eggs = eggGroup.selectAll('image')
      .data(Array.from({ length: eggCount }))
      .enter()
      .append('image')
      .attr('xlink:href', iconEgg)
      .attr('width', iconWidth)
      .attr('height', iconHeight)
      .attr('x', (d, j) => (j % maxIconsPerRow) * horizontalSpacing)
      .attr('y', (d, j) => Math.floor(j / maxIconsPerRow) * iconHeight);

    const hatchGroup = eggGroup.append('g');

    hatchGroup.selectAll('image')
      .data(Array.from({ length: hatchCount }))
      .enter()
      .append('image')
      .attr('xlink:href', iconHatch)
      .attr('width', iconWidth)
      .attr('height', iconHeight)
      .attr('x', (d, j) => (j % 20) * horizontalSpacing)
      .attr('y', (d, j) => Math.floor(j / 20) * iconHeight)
      .attr('opacity', 0)
      .transition()
      .delay(1000)
      .duration(2000)
      .attr('opacity', 1);

    eggs.transition()
      .delay(1000)
      .duration(2000)
      .attr('opacity', (d, j) => (j < hatchCount ? 0 : 1));
  });
},

fetchTurtleData() {
fetch('sea_turtle_types.json')
.then(response => response.json())
.then(data => {
  this.createWaffleChart(data);
})
.catch(error => {
  console.error('Error fetching JSON data:', error);
});
},

createWaffleChart(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 100 : 30; // Increased gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles
  const yearLabelWidth = 50; // Space for year label at the start of each row

  // Flatten data to a suitable structure
  const newData = [];
  data.forEach(d => {
    ["Green turtle", "Hawksbill turtle", "Olive ridley turtle", "Leatherback turtle"].forEach(type => {
      newData.push({
        Year: d.Year,
        Type: type,
        Counts: parseInt(d[type], 10)
      });
    });
  });

  const itemsPerRow = 4; // Each year will be represented on a new line
  const totalRows = data.length;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain(["Green sea turtle", "Hawksbill turtle", "Olive ridley turtle", "Leatherback turtle"]);

  // Calculate total width and height of the grid
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - (itemsPerRow * (squareSide + gap))) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.waffleChart).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  newData.forEach((d, i) => {
    const maxCount = Math.max(...newData.map(d => d.Counts));
    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);
    const x = colIndex * (squareSide + gap) + yearLabelWidth;
    const y = rowIndex * (squareSide + labelHeight + gap);

    // Year label for each row
    if (colIndex === 0) {
      svg.append("text")
        .attr("x", 10) // Small padding from the left edge
        .attr("y", y + squareSide / 2 + labelHeight)
        .attr("text-anchor", "left")
        .text(d.Year);
    }

    const g = svg.append("g").attr("transform", `translate(${x}, ${y})`);

    let rectHeight = Math.max(d.Counts / maxCount * squareSide, minHeight);
    const innerRectY = squareSide - rectHeight;

    // Outer rectangle boundary
    g.append("rect")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "none")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Inner rectangle for visualizing counts
    const innerRect = g.append("rect")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", 'none')
      

    // Create dots
    const dots = Array.from({length: d.Counts}, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * rectHeight + innerRectY
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter()
      .append("circle")
      .attr("class", "dot")
      .attr("cx", d => d.x)
      .attr("cy", squareSide) // Start from bottom of square
      .attr("r", 0)
      .attr("fill", colorScale(d.Type));

    // Add text label for the type
    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + labelHeight)
      .attr("text-anchor", "middle")
      .text(d.Type);

    // Apply animation with IntersectionObserver
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0)
            .attr("r", 0)
            .transition()
            .duration(1000)
            .delay((_, i) => i * 5)
            .attr("cy", d => d.finalY)
            .attr("r", 3);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},

fetchFifthData() {
  fetch('sea_turtle_strand.json')
    .then(response => response.json())
    .then(originalData => {
      const data = originalData.map(d => ({
        Year: d.Year,
        Egg: Number(d.Strand),
        Dead: d.Dead === 'No data' ? 'No data' : Number(d.Dead),
        Alive: d.Alive === 'No data' ? 'No data' : Number(d.Alive)
      }));

      this.createtotalChart(data);
      this.createalivedeadChart(data);
    })
    .catch(error => {
      console.error('Error fetching JSON data:', error);
    });
},

createtotalChart(data) {
  const svgWidth = window.innerWidth;
  const svgHeight = window.innerHeight;
  const svg = d3.select(this.$refs.totalChart).append('svg')
    .attr('width', svgWidth)
    .attr('height', svgHeight);

  const iconEgg = 'strand.svg'; // SVG path starting from the public directory
  const iconUnits = 10;
  const iconWidth = 40;
  const iconHeight = 40;
  const horizontalSpacing = 50;
  const rowHeight = 140; // Increased row height for more spacing
  const maxIconsPerRow = 25;
  const fontSize = 16; // Font size for the legend text
  const legendText = ' = 1000 units'; // Define the legend text
// Calculate text width approximately (assuming roughly 8 pixels per character average at font size 16)
const textWidth = legendText.length * 8;

// Calculate the starting x position for the icon so that the entire legend (icon + text) is centered
const startX = (svgWidth - (iconWidth + textWidth + 10)) / 2; // 10 pixels padding between icon and text

// Append the icon for the legend
svg.append('image')
  .attr('xlink:href', iconEgg)
  .attr('x', startX)
  .attr('width', iconWidth)
  .attr('height', iconHeight);

// Append the text for the legend
svg.append('text')
  .attr('x', startX + iconWidth + 10) // Start text right after the icon with 10 pixels padding
  .attr('y', 25) // Align text vertically with the center of the icon
  .attr('font-size', fontSize)
  .attr('font-weight', 'bold')
  .attr('text-anchor', 'start') // Start the text at the specified x position
  .text(legendText);

  const totalHeight = data.length * rowHeight;
  const yOffset = (svgHeight - totalHeight) / 2; // Calculate offset to center the visualization vertically

  data.forEach((d, i) => {
    const eggCount = Math.ceil(d.Egg / iconUnits);
    const actualIconsThisRow = Math.min(eggCount, maxIconsPerRow);
    const actualRowWidth = actualIconsThisRow * horizontalSpacing;
    const xPosition = (svgWidth - actualRowWidth) / 2;

    const yPosition = yOffset + i * rowHeight; // Adjust y position based on offset

    svg.append('text')
      .attr('x', xPosition-10)
      .attr('y', yPosition + iconHeight / 2 + 20)
      .attr('font-size', 16)
      .attr('font-weight', 'bold')
      .attr('text-anchor', 'end')
      .text(d.Year);

    const eggGroup = svg.append('g')
      .attr('transform', `translate(${xPosition}, ${yPosition})`);

    eggGroup.selectAll('image')
      .data(Array.from({ length: eggCount }))
      .enter()
      .append('image')
      .attr('xlink:href', iconEgg)
      .attr('width', iconWidth)
      .attr('height', iconHeight)
      .attr('x', (d, j) => (j % maxIconsPerRow) * horizontalSpacing)
      .attr('y', (d, j) => Math.floor(j / maxIconsPerRow) * iconHeight);
  });
},

createalivedeadChart(data) {
  const svgWidth = window.innerWidth;
  const svgHeight = window.innerHeight;
  const svg = d3.select(this.$refs.alivedeadChart).append('svg')
    .attr('width', svgWidth)
    .attr('height', svgHeight);

  const iconEgg = 'strand.svg';  // Make sure the SVG is accessible
  const iconHatch = 'dead.svg';  // Make sure the SVG is accessible
  const iconUnits = 10;
  const iconWidth = 40;
  const iconHeight = 40;
  const horizontalSpacing = 50;
  const rowHeight = 160;  // Adjusted for clear spacing
  const maxIconsPerRow = 25;

  data.forEach((d, i) => {
    const eggCount = Math.ceil(d.Egg / iconUnits);
    const hatchCount = Math.ceil(d.Dead / iconUnits);
    const yPosition = i * rowHeight;

    const actualIconsThisRow = Math.min(eggCount, maxIconsPerRow);
    const actualRowWidth = actualIconsThisRow * horizontalSpacing;
    const xPosition = (svgWidth - actualRowWidth) / 2;

    svg.append('text')
      .attr('x', xPosition - 10)
      .attr('y', yPosition + iconHeight / 2 + 20) // Adjusted for vertical centering
      .attr('font-size', 16)
      .attr('font-weight', 'bold')
      .attr('text-anchor', 'end')
      .text(d.Year);

    const eggGroup = svg.append('g')
      .attr('transform', `translate(${xPosition}, ${yPosition})`);

    // Render "strand" icons
    eggGroup.selectAll('.egg-icon')
      .data(Array.from({ length: eggCount }))
      .enter()
      .append('image')
      .attr('class', 'egg-icon')
      .attr('xlink:href', iconEgg)
      .attr('width', iconWidth)
      .attr('height', iconHeight)
      .attr('x', (d, j) => (j % maxIconsPerRow) * horizontalSpacing)
      .attr('y', (d, j) => Math.floor(j / maxIconsPerRow) * iconHeight)
      .attr('opacity', (d, j) => j < hatchCount ? 0 : 1); // Only show if not replaced by a dead icon

    // Render "dead" icons where needed
    eggGroup.selectAll('.dead-icon')
      .data(Array.from({ length: hatchCount }))
      .enter()
      .append('image')
      .attr('class', 'dead-icon')
      .attr('xlink:href', iconHatch)
      .attr('width', iconWidth)
      .attr('height', iconHeight)
      .attr('x', (d, j) => (j % maxIconsPerRow) * horizontalSpacing)
      .attr('y', (d, j) => Math.floor(j / maxIconsPerRow) * iconHeight)
      .attr('opacity', 1); // Ensure visibility of dead icons
  });
},

fetchSixthData() {
fetch('sea_turtle_strandreason.json') // Replace with the path to your secondary data file
          .then(response => response.json())
          .then(data => {
            // Once data is fetched, call the method to create the secondary visualization
            this.Createstrand (data);
          })
          .catch(error => {
            console.error('Error fetching secondary data:', error);
          });
      },
  
Createstrand(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 100 : 50; // Increased gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles
  const yearLabelWidth = 50; // Space for year label at the start of each row

  // Flatten data to a suitable structure
  const newData = [];
  data.forEach(d => {
   ["Fishing Gear", "Trash","Sick", "Undefined"].forEach(type => {
      newData.push({
        Year: d.Year,
        Type: type,
        Counts: parseInt(d[type], 10)
      });
    });
  });

  const itemsPerRow = 4; // Each year will be represented on a new line
  const totalRows = data.length;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain("Fishing Gear", "Trash","Sick", "Undefined");

  // Calculate total width and height of the grid
  const gridWidth = itemsPerRow * (squareSide + gap) + yearLabelWidth;
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - gridWidth) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.sixthVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  newData.forEach((d, i) => {
    const maxCount = Math.max(...newData.map(d => d.Counts));
    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);
    const x = colIndex * (squareSide + gap) + yearLabelWidth;
    const y = rowIndex * (squareSide + labelHeight + gap);

    // Year label for each row
    if (colIndex === 0) {
      svg.append("text")
        .attr("x", 10) // Small padding from the left edge
        .attr("y", y + squareSide / 2 + labelHeight)
        .attr("text-anchor", "left")
        .text(d.Year);
    }
    const g = svg.append("g").attr("transform", `translate(${x}, ${y})`);

    let rectHeight = Math.max(d.Counts / maxCount * squareSide, minHeight);
    const innerRectY = squareSide - rectHeight;

    // Outer rectangle boundary
    g.append("rect")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "none")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Inner rectangle for visualizing counts
    const innerRect = g.append("rect")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", 'none')
      

    // Create dots
    const dots = Array.from({length: d.Counts}, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * rectHeight + innerRectY
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter()
      .append("circle")
      .attr("class", "dot")
      .attr("cx", d => d.x)
      .attr("cy", squareSide) // Start from bottom of square
      .attr("r", 0)
      .attr("fill", colorScale(d.Type));

    // Add text label for the type
    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + labelHeight)
      .attr("text-anchor", "middle")
      .text(d.Type);

      const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0)
            .attr("r", 0)
            .transition()
            .duration(1000)
            .delay((_, i) => i * 5)
            .attr("cy", d => d.finalY)
            .attr("r", 3);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},
 

fetchSevenData() {
fetch('sea_turtle_trash.json') // Replace with the path to your secondary data file
          .then(response => response.json())
          .then(data => {
            // Once data is fetched, call the method to create the secondary visualization
            this.createProportionaltrasheffectChart (data);
          })
          .catch(error => {
            console.error('Error fetching secondary data:', error);
          });
      },

createProportionaltrasheffectChart(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 100 : 50; // Increased gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles
  const yearLabelWidth = 50; // Space for year label at the start of each row

  // Flatten data to a suitable structure
  const newData = [];
  data.forEach(d => {
   ["Eat", "Tie", "Eat and Tie"].forEach(type => {
      newData.push({
        Year: d.Year,
        Type: type,
        Counts: parseInt(d[type], 10)
      });
    });
  });

  const itemsPerRow = 3; // Each year will be represented on a new line
  const totalRows = data.length;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain("Eat", "Tie", "Eat and Tie");

  // Calculate total width and height of the grid
  const gridWidth = itemsPerRow * (squareSide + gap) + yearLabelWidth;
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - gridWidth) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.sevenVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  newData.forEach((d, i) => {
    const maxCount = Math.max(...newData.map(d => d.Counts));
    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);
    const x = colIndex * (squareSide + gap) + yearLabelWidth;
    const y = rowIndex * (squareSide + labelHeight + gap);

    // Year label for each row
    if (colIndex === 0) {
      svg.append("text")
        .attr("x", 10) // Small padding from the left edge
        .attr("y", y + squareSide / 2 + labelHeight)
        .attr("text-anchor", "left")
        .text(d.Year);
    }

    const g = svg.append("g").attr("transform", `translate(${x}, ${y})`);

    let rectHeight = Math.max(d.Counts / maxCount * squareSide, minHeight);
    const innerRectY = squareSide - rectHeight;

    // Outer rectangle boundary
    g.append("rect")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "none")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Inner rectangle for visualizing counts
    const innerRect = g.append("rect")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", 'none')
      

    // Create dots
    const dots = Array.from({length: d.Counts}, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * rectHeight + innerRectY
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter()
      .append("circle")
      .attr("class", "dot")
      .attr("cx", d => d.x)
      .attr("cy", squareSide) // Start from bottom of square
      .attr("r", 0)
      .attr("fill", colorScale(d.Type));

    // Add text label for the type
    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + labelHeight)
      .attr("text-anchor", "middle")
      .text(d.Type);

    // Apply animation with IntersectionObserver
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0) // Reset the dots' positions
            .attr("r", 0) // Reset the radius
            .transition()
            .duration(1000)
            .delay((_, i) => i * 3)
            .attr("cy", dot => dot.finalY)
            .attr("r", 3); // Animate to final radius size

          // No need to unobserve, ensure animation restarts
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},

fetchEightData() {
  // Fetch data for the secondary visualization
  fetch('sea_turtle_trashcattotal.json')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Once data is fetched, call the method to create the secondary visualization
      this.createProportionalTrash(data);
    })
    .catch(error => {
      console.error('Error fetching secondary data:', error);
    });
},

createProportionalTrash(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 60 : 20; // Gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles

  // Calculate the number of items per row dynamically based on available width
  const itemsPerRow = 4;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain(data.map(d => d.Category)); // Assuming 'Category' is unique

  // Calculate total number of rows
  const totalRows = Math.ceil(data.length / itemsPerRow);

  // Calculate total width and height of the grid
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - (itemsPerRow * (squareSide + gap))) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.eightVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g");

  const chartGroup = svg.append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  data.forEach((d, i) => {
    const maxCount = Math.max(...data.map(d => d.Total)); // Define maxCount here

    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);

    const x = colIndex * (squareSide + gap);
    const y = rowIndex * (squareSide + labelHeight + gap);

    const g = chartGroup.append("g").attr("transform", `translate(${x}, ${y})`);

    const scaleFactor = 80 / maxCount;

    // Ensure inner rectangle has a minimum height
    let rectHeight = d.Total * scaleFactor;
    rectHeight = Math.max(rectHeight, minHeight);

    // Append outer rectangle without assigning it to a variable
    g.append("rect")
      .attr("class", "outer-container")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "transparent")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Append inner rectangle positioned at the bottom of the outer rectangle
    const innerRectY = squareSide - rectHeight;
    const innerRect = g.append("rect")
      .attr("class", "container")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", "transparent")
      .attr("stroke-width", 1);

    // Append circles within rectangle
    const dots = Array.from({ length: d.Total }, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * (rectHeight - 2) + innerRectY + 1,
      color: colorScale(d.Category)
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter().append("circle")
      .attr("class", "dot")
      .attr("cx", dot => dot.x)
      .attr("cy", 0)
      .attr("r", 0)
      .style("fill", dot => dot.color);

    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + 15)
      .attr("text-anchor", "middle")
      .text(d.Category);

    // Intersection observer to start animation on scroll
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0) // Reset the dots' positions
            .attr("r", 0) // Reset the radius
            .transition()
            .duration(1000)
            .delay((_, i) => i * 3)
            .attr("cy", dot => dot.finalY)
            .attr("r", 3); // Animate to final radius size

          // No need to unobserve, ensure animation restarts
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},

fetchNinethData() {
      // Fetch data for the secondary visualization
      fetch('sea_turtle_trashcat.json')
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // Once data is fetched, call the method to create the secondary visualization
          this.createChart(data);
        })
        .catch(error => {
          console.error('Error fetching secondary data:', error);
        });
      },
  createChart(data) {
        let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 100 : 50; // Increased gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles
  const yearLabelWidth = 50; // Space for year label at the start of each row

  // Flatten data to a suitable structure
  const newData = [];
  data.forEach(d => {
   [ "Plastic", "Fishing Gear", "Manufacturing Tools", "Other"].forEach(type => {
      newData.push({
        Year: d.Year,
        Type: type,
        Counts: parseInt(d[type], 10)
      });
    });
  });

  const itemsPerRow = 4; // Each year will be represented on a new line
  const totalRows = data.length;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain("Plastic", "Fishing Gear", "Manufacturing Tools", "Other");

  // Calculate total width and height of the grid
  const gridWidth = itemsPerRow * (squareSide + gap) + yearLabelWidth;
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - gridWidth) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.trashyearVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  newData.forEach((d, i) => {
    const maxCount = Math.max(...newData.map(d => d.Counts));
    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);
    const x = colIndex * (squareSide + gap) + yearLabelWidth;
    const y = rowIndex * (squareSide + labelHeight + gap);

    // Year label for each row
    if (colIndex === 0) {
      svg.append("text")
        .attr("x", 10) // Small padding from the left edge
        .attr("y", y + squareSide / 2 + labelHeight)
        .attr("text-anchor", "left")
        .text(d.Year);
    }

    const g = svg.append("g").attr("transform", `translate(${x}, ${y})`);

    let rectHeight = Math.max(d.Counts / maxCount * squareSide, minHeight);
    const innerRectY = squareSide - rectHeight;

    // Outer rectangle boundary
    g.append("rect")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "none")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Inner rectangle for visualizing counts
    const innerRect = g.append("rect")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", 'none')
      

    // Create dots
    const dots = Array.from({length: d.Counts}, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * rectHeight + innerRectY
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter()
      .append("circle")
      .attr("class", "dot")
      .attr("cx", d => d.x)
      .attr("cy", squareSide) // Start from bottom of square
      .attr("r", 0)
      .attr("fill", colorScale(d.Type));

    // Add text label for the type
    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + labelHeight)
      .attr("text-anchor", "middle")
      .text(d.Type);

    // Apply animation with IntersectionObserver
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .transition()
            .duration(1000)
            .delay((_, i) => i * 5)
            .attr("cy", d => d.finalY)
            .attr("r", 3);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},

fetchTenData() {
  // Fetch data for the secondary visualization
  fetch('sea_turtle_trashtop10.json')
    .then(response => response.json())
    .then(data => {
      // Once data is fetched, call the method to create the secondary visualization
      this.createTop10Chart(data);
    })
    .catch(error => {
      console.error('Error fetching secondary data:', error);
    });
},

createTop10Chart(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 100 : 50; // Gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles

  // Calculate the number of items per row dynamically based on available width
  const availableWidth = window.innerWidth;
  const itemsPerRow = Math.floor(availableWidth / (squareSide + gap));

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain(data.map(d => d.Types)); // Assuming 'Types' is unique

  // Calculate total number of rows
  const totalRows = Math.ceil(data.length / itemsPerRow);

  // Calculate total width and height of the grid
  const gridWidth = itemsPerRow * (squareSide + gap);
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - gridWidth) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.tenVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g");

  const chartGroup = svg.append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  data.forEach((d, i) => {
    const maxCount = Math.max(...data.map(d => d.counts));
    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);
    const x = colIndex * (squareSide + gap);
    const y = rowIndex * (squareSide + labelHeight + gap);

    const g = chartGroup.append("g").attr("transform", `translate(${x}, ${y})`);
    let rectHeight = Math.max(d.counts * (80 / maxCount), minHeight);

    g.append("rect")
      .attr("class", "outer-container")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "transparent")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    const innerRectY = squareSide - rectHeight;
    const innerRect = g.append("rect")
      .attr("class", "container")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", innerRectY)
      .attr("fill", "transparent")
      .attr("stroke-width", 1);

    const dots = Array.from({ length: d.counts }, () => ({
      x: Math.random() * squareSide,
      finalY: Math.random() * (rectHeight - 2) + innerRectY + 1,
      color: colorScale(d.Types)
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter().append("circle")
      .attr("class", "dot")
      .attr("cx", d => d.x)
      .attr("cy", 0)
      .attr("r", 0)
      .style("fill", d => d.color);

    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + 15)
      .attr("text-anchor", "middle")
      .text(d.Types);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0)
            .attr("r", 0)
            .transition()
            .duration(1000)
            .delay((_, i) => i * 5)
            .attr("cy", d => d.finalY)
            .attr("r", 3);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
}
}
}
  </script>
  
  <style>
.tooltip {
  position: absolute;
  text-align: center;
  width: auto;
  height: auto;
  padding: 5px;
  font: 12px sans-serif;
  background: lightsteelblue;
  border: 0;
  border-radius: 8px;
  pointer-events: none;
}

    </style>
  